module.exports = __webpack_public_path__ + "img/live20220519_foreshow.9b31cc1a.jpg";